/* Helen K Art theme JS - cart, variants, search, mobile nav */
(function () {
  'use strict';

  var routes = window.theme && window.theme.routes ? window.theme.routes : {};

  /* ---------- Cart count / drawer refresh helpers ---------- */
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCartCountBubbles(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function refreshCartCount() {
    fetchCart().then(updateCartCountBubbles).catch(function () {});
  }
  window.themeRefreshCartCount = refreshCartCount;

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) { errorEl.textContent = ''; errorEl.hidden = true; }
    if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = submitBtn.dataset.addingText || 'Adding…'; }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error(result.data && result.data.description ? result.data.description : 'Could not add item to cart');
        }
        refreshCartCount();
        if (submitBtn) { submitBtn.textContent = submitBtn.dataset.addedText || 'Added ✓'; }
        document.dispatchEvent(new CustomEvent('theme:cart:added', { detail: result.data }));
        var drawer = document.querySelector('[data-cart-drawer]');
        if (drawer) {
          openCartDrawer();
          refreshCartDrawer();
        }
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      })
      .finally(function () {
        if (submitBtn) {
          setTimeout(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.dataset.originalText || 'Add to cart';
          }, 1200);
        }
      });
  });

  /* ---------- Cart drawer ---------- */
  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) drawer.classList.add('is-open');
  }
  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) drawer.classList.remove('is-open');
  }
  function refreshCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      openCartDrawer();
      refreshCartDrawer();
    }
    if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-overlay]')) {
      closeCartDrawer();
    }
    if (e.target.closest('[data-search-toggle]')) {
      e.preventDefault();
      var modal = document.querySelector('[data-search-modal]');
      if (modal) {
        modal.classList.add('is-open');
        var input = modal.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    }
    if (e.target.closest('[data-search-close]') || e.target.matches('[data-search-overlay]')) {
      var m = document.querySelector('[data-search-modal]');
      if (m) m.classList.remove('is-open');
    }
    if (e.target.closest('[data-mobile-nav-toggle]')) {
      document.documentElement.classList.toggle('mobile-nav-open');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      var m = document.querySelector('[data-search-modal]');
      if (m) m.classList.remove('is-open');
    }
  });

  /* ---------- Cart quantity updates on cart page / drawer ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var key = input.dataset.cartQty;
    var qty = parseInt(input.value, 10) || 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCountBubbles(cart);
        if (document.querySelector('[data-cart-drawer]')) refreshCartDrawer();
        if (document.querySelector('[data-cart-page]')) window.location.reload();
      });
  });

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    var key = removeBtn.dataset.cartRemove;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCountBubbles(cart);
        if (document.querySelector('[data-cart-drawer]')) refreshCartDrawer();
        if (document.querySelector('[data-cart-page]')) window.location.reload();
      });
  });

  /* ---------- Predictive search ---------- */
  var searchTimer;
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-predictive-search-input]');
    if (!input) return;
    clearTimeout(searchTimer);
    var query = input.value.trim();
    var resultsEl = document.querySelector('[data-search-results]');
    if (!resultsEl) return;
    if (query.length < 2) { resultsEl.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            resultsEl.innerHTML = '<p class="no-results">No products found.</p>';
            return;
          }
          resultsEl.innerHTML = products
            .map(function (p) {
              var img = p.featured_image ? p.featured_image.url : '';
              return (
                '<a href="' + p.url + '">' +
                (img ? '<img src="' + img + '" alt="" loading="lazy" width="50" height="50">' : '') +
                '<span>' + p.title + '</span>' +
                '</a>'
              );
            })
            .join('');
        })
        .catch(function () {});
    }, 250);
  });

  /* ---------- Variant picker ---------- */
  function initVariantPickers() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var variantsJson = form.querySelector('[data-variants-json]');
      if (!variantsJson) return;
      var variants;
      try { variants = JSON.parse(variantsJson.textContent); } catch (err) { return; }

      function getSelectedOptions() {
        var selected = [];
        form.querySelectorAll('[data-option-index]').forEach(function (group) {
          var checked = group.querySelector('input:checked, select');
          if (checked) selected[parseInt(group.dataset.optionIndex, 10)] = checked.value;
        });
        return selected;
      }

      function findVariant(options) {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === options[i]; });
        });
      }

      function updatePriceAndAvailability(variant) {
        var priceBox = form.querySelector('[data-price-box]');
        var addBtn = form.querySelector('[type="submit"]');
        var idInput = form.querySelector('[name="id"]');
        var skuEl = form.querySelector('[data-sku]');

        if (!variant) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (skuEl) skuEl.textContent = variant.sku || '';

        if (priceBox) {
          var money = variant.price_formatted || variant.price;
          var compareAt = variant.compare_at_price_formatted;
          var html = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += '<s>' + compareAt + '</s> <span class="sale">' + money + '</span>';
          } else {
            html += '<span>' + money + '</span>';
          }
          priceBox.innerHTML = html;
        }

        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.dataset.addText || 'Add to cart';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold out';
          }
        }

        form.querySelectorAll('[data-variant-image]').forEach(function (img) {
          if (variant.featured_image) img.src = variant.featured_image;
        });
      }

      form.addEventListener('change', function (e) {
        if (!e.target.closest('[data-option-index]')) return;
        var options = getSelectedOptions();
        var variant = findVariant(options);
        updatePriceAndAvailability(variant);
      });

      var initial = getSelectedOptions();
      updatePriceAndAvailability(findVariant(initial));
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrapper = btn.closest('.qty-selector');
    var input = wrapper && wrapper.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(input.step, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var val = parseInt(input.value, 10) || min;
    val = btn.dataset.qtyStep === 'up' ? val + step : Math.max(min, val - step);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('.product-gallery');
    if (!gallery) return;
    var mainImg = gallery.querySelector('.main img');
    if (mainImg) mainImg.src = thumb.dataset.thumb;
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------- Newsletter form (native Shopify customer form; just UX polish) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-newsletter-form]');
    if (!form) return;
    // Let Shopify's native customer form handle submission; just show optimistic state.
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.textContent = 'Joining…';
  });

  /* ---------- Product recommendations ---------- */
  function loadProductRecommendations() {
    var container = document.querySelector('[data-product-recommendations]');
    if (!container || !container.dataset.url) return;
    fetch(container.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('[data-product-recommendations], .prod-grid, .sec-head');
        if (doc.body.innerHTML.trim() !== '') {
          container.innerHTML = doc.body.innerHTML;
        }
      })
      .catch(function () {});
  }

  /* ---------- Load more (client-side reveal, no layout shift) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more-btn]');
    if (!btn) return;
    var section = btn.closest('section, .page-section, div');
    var grid = section ? section.querySelector('[data-load-more-grid]') : document.querySelector('[data-load-more-grid]');
    if (!grid) return;
    var step = parseInt(grid.dataset.step, 10) || 8;
    var hiddenItems = Array.prototype.slice.call(grid.querySelectorAll('[data-load-more-item].is-hidden'));
    hiddenItems.slice(0, step).forEach(function (item) {
      item.classList.remove('is-hidden');
    });
    var remaining = grid.querySelectorAll('[data-load-more-item].is-hidden').length;
    if (remaining === 0) {
      btn.style.display = 'none';
    }
  });

  /* ---------- Collection page: AJAX "Load more" (fetches next page, appends products) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-collection-load-more]');
    if (!btn) return;
    var sectionId = btn.dataset.sectionId;
    var nextUrl = btn.dataset.nextUrl;
    if (!nextUrl || !sectionId) return;

    var grid = document.querySelector('[data-collection-grid]');
    if (!grid) return;

    var separator = nextUrl.indexOf('?') > -1 ? '&' : '?';
    var fetchUrl = nextUrl + separator + 'section_id=' + sectionId;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Loading…';

    fetch(fetchUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-collection-grid]');
        if (newGrid) {
          Array.prototype.forEach.call(newGrid.children, function (child) {
            grid.appendChild(child);
          });
        }
        var newBtn = doc.querySelector('[data-collection-load-more]');
        if (newBtn) {
          btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          btn.disabled = false;
          btn.textContent = originalText;
        } else {
          btn.parentElement.removeChild(btn);
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    initVariantPickers();
    loadProductRecommendations();
  });
})();
